import { CircleUser, Cog, File, Search } from "lucide-react";
import Button from "../common/Button";
import Dropdown, { DropdownContent, DropdownTrigger } from "../common/Dropdown";
import Link from "next/link";
import { useState } from "react";
import Image from "next/image";

interface SidebarIdeProps {
    toggleExplorer: () => void;
    activeTab: string;
    setActiveTab: (tab: string) => void;
    clearUrl: () => void;
}

export default function SidebarIde({
    toggleExplorer,
    activeTab,
    setActiveTab,
    clearUrl,
}: SidebarIdeProps) {
    const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);

    return (
        <div className="w-14 border-r border-white/15 flex-col items-center justify-between p-2 hidden lg:flex">
            <div className="flex flex-col items-center justify-center gap-2">
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => {
                        toggleExplorer();
                    }}
                    className={activeTab === "file" ? "bg-white/10" : ""}
                >
                    <File className="size-5 text-white/70 group-hover:text-white" />
                </Button>
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => {
                        setActiveTab("search");
                        clearUrl();
                    }}
                    className={activeTab === "search" ? "bg-white/10" : ""}
                >
                    <Search className="size-5 text-white/70 group-hover:text-white" />
                </Button>
            </div>

            <div className="flex flex-col items-center justify-center gap-2">
                <Dropdown
                    placement="right-bottom"
                    className=""
                    open={profileDropdownOpen}
                    onOpenChange={setProfileDropdownOpen}
                    role="menu"
                    ariaLabel="Profile actions"
                >
                    <DropdownTrigger asChild>
                        <Button
                            variant="ghost"
                            size="icon"
                            className={profileDropdownOpen ? "bg-white/10" : ""}
                        >
                            <CircleUser className="size-5 text-white/70 group-hover:text-white" />
                        </Button>
                    </DropdownTrigger>
                    <DropdownContent className="card min-w-52 rounded-lg!">
                        <Link
                            href="https://github.com/"
                            target="_blank"
                            rel="noreferrer"
                            className="rounded-lg px-3 py-2 text-xs h-[calc(40px-2px)] text-white/70 hover:bg-white/10 hover:text-white flex items-center gap-2"
                            onClick={() => setProfileDropdownOpen(false)}
                        >
                            <Image src="/images/github.svg" alt="GitHub" width={20} height={20} className="size-4" />
                            <span>Voir le compte GitHub</span>
                        </Link>
                    </DropdownContent>
                </Dropdown>
            </div>
        </div>
    )
}
